import React, { FC } from 'react'

type GridProps = {
  columns: number
}

const Grid: FC<GridProps> = ({ children, columns }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gridGap: 10,
      maxWidth: '650px',
    }}
  >
    {children}
  </div>
)

export default Grid
